module.exports=function(scope){ return `// Signal to the FaceTec SDK that audit trail should be captured
[[Zoom sdk].auditTrailType = ZoomAuditTrailTypeHeight640;

// Capture a User Session
UIViewController *sessionVC = [Zoom.sdk createSessionVCWithDelegate:self];
[self presentViewController:sessionVC animated:true completion:nil];

// Sample code to handle the session result
- (void) onZoomSessionResultWithResult:(ZoomSessionResult *)result {
    NSLog(@"Session result: %@", [@(result.status) stringValue]);

    // Session failed
    if ([result status] != ZoomSessionStatusUserProcessedSuccessfully) {
        // Handle results here
        return;
    }
    // retrieve the FaceTec SDK face biometric results
    ZoomFaceBiometricMetrics *faceMetrics = [result faceMetrics];

    if (faceMetrics != nil) {
        // Get the auidt trail image(s) if available
        NSArray<UIImage*> *auditTrail = (id) faceMetrics.auditTrailCompressedBase64;
        // Check the audit trail image count
        NSLog(@"Audit trail image count result: %@", [@(auditTrail.count) stringValue]);
        // Get the auidt trail history if available
        NSArray<NSArray<UIImage*>*> *auditTrailHistory = (id) faceMetrics.auditTrailCompressedBase64History;
    }
    // Send the data to your chosen API for processing
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/17-zoom-audit-trail.m.tpl